/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  FcmTokensControllerSubscribeToFcmMutationRequest,
  FcmTokensControllerSubscribeToFcmMutationResponse,
  FcmTokensControllerSubscribeToFcm401,
} from '../types/FcmTokensControllerSubscribeToFcm.ts';

function getFcmTokensSubscribeToFcmUrl() {
  const res = { method: 'POST', url: `/api/notifications/subscribe-fcm` as const };
  return res;
}

/**
 * {@link /api/notifications/subscribe-fcm}
 */
export async function fcmTokensSubscribeToFcm(
  data: FcmTokensControllerSubscribeToFcmMutationRequest,
  config: Partial<RequestConfig<FcmTokensControllerSubscribeToFcmMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    FcmTokensControllerSubscribeToFcmMutationResponse,
    ResponseErrorConfig<FcmTokensControllerSubscribeToFcm401>,
    FcmTokensControllerSubscribeToFcmMutationRequest
  >({ method: 'POST', url: getFcmTokensSubscribeToFcmUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
